import { ReducerUtils } from "../constants/reducers";

export default function reducer(state, action) {
  switch (action.type) {
    case ReducerUtils.partner.details:
      return {
        ...state,
        partnerDetails: action.payload,
      };

    case ReducerUtils.proposal.list:
      return {
        ...state,
        proposalList: action.payload,
      };

    case ReducerUtils.product.details:
      return {
        ...state,
        productDetails: action.payload,
      };

    case ReducerUtils.product.savingGrid:
      return {
        ...state,
        savingGrid: action.payload,
      };

    case ReducerUtils.overview.details:
      return {
        ...state,
        overviewDetails: action.payload,
      };

    case ReducerUtils.city.list:
      return {
        ...state,
        cities: action.payload,
      };

    case ReducerUtils.state.list:
      return {
        ...state,
        states: action.payload,
      };

    case ReducerUtils.occupation.list:
      return {
        ...state,
        occupations: action.payload,
      };

    case ReducerUtils.bank.list:
      return {
        ...state,
        banks: action.payload,
      };

    case ReducerUtils.mandate.list:
      return {
        ...state,
        mandates: action.payload,
      };

    case ReducerUtils.pincode.list:
      return {
        ...state,
        pincodes: action.payload,
      };

    case ReducerUtils.pincode.search:
      var filteredList = state.pincodes.filter(function (item) {
        return item.pincode == action.payload;
      });

      return {
        ...state,
        searchTerm: action.payload,
        result: filteredList,
      };

    case ReducerUtils.proposal.documents:
      return {
        ...state,
        documents: action.payload,
      };

    case ReducerUtils.ifsc_code.list:
      return {
        ...state,
        ifsc_codes: action.payload,
      };

    default:
      return state;
  }
}
